module.exports = __webpack_public_path__ + "static/media/HelveticaNeueCyr-Black.5e3e693f.woff";